export default "__VITE_ASSET__$CpY5V02__"